// components/LandingPage.tsx
import React from 'react';
import DataCollectionSection from './DataCollectionSection';
import IoTLabSection from './IoTLabSection';
import DataServicesSection from './DataServicesSection';

export default function LandingSkillPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      {/* 기술/스킬 홍보 섹션 그룹 */}
      <main className="relative">
        <DataCollectionSection />
        <IoTLabSection />
        <DataServicesSection />
      </main>

      {/* 추가 섹션들... */}
    </div>
  );
}
